export default "__VITE_ASSET__B90$WxS3__";